import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '@mui/material';

import PasswordForm from './Account/Form';

const AccountCard = ({ tabInfos, isPasswordUpdated, setIsPasswordUpdated }) => (
  <Box>
    <FontAwesomeIcon icon={tabInfos.icon} />
    <Box component='span' sx={{ marginLeft: '5px', fontSize: '1rem', fontWeight: '700', textTransform: 'uppercase' }}>
      {tabInfos.title}
    </Box>
    <Box sx={{ paddingTop: '30px' }}>
      <PasswordForm isPasswordUpdated={isPasswordUpdated} setIsPasswordUpdated={setIsPasswordUpdated} />
    </Box>
  </Box>
);

export default React.memo(AccountCard);
